export default __webpack_public_path__ + "static/media/gel-buffer-2.e850ed95.svg";